import { render, staticRenderFns } from "./DeveloperContactCard.vue?vue&type=template&id=0970f791&scoped=true&"
import script from "./DeveloperContactCard.vue?vue&type=script&lang=js&"
export * from "./DeveloperContactCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0970f791",
  null
  
)

export default component.exports